import request from "../../utils/request";
import { Result } from "../../models/general";
import type {
  StatutoryCatalogueTemplateView,
  StatutoryLeaveTemplateInput,
  StatutoryLeaveTemplateView,
} from "../../models/attendance";

// The platform's statutory leave catalogue (spec statutory-templates-per-company.md, sections 7 and 8.2).
// Operator only: OperatorStatutoryTemplateController carries Policy = "Operator" and the service checks the role
// again. The Operator never reads a company's copies; the catalogue rows carry copy COUNTS only.

export async function getStatutoryCatalogue(countryId?: number | null, includeArchived = false) {
  const params = new URLSearchParams();
  if (countryId) params.set("countryId", String(countryId));
  if (includeArchived) params.set("includeArchived", "true");
  const query = params.toString();
  const response = await request.get<Result<StatutoryCatalogueTemplateView[]>>(
    `Operator/StatutoryTemplate${query ? `?${query}` : ""}`);
  return response.data;
}

/** Creates a catalogue row; the server copies it into every live company that uses the country, in the same save. */
export async function createStatutoryCatalogueTemplate(input: StatutoryLeaveTemplateInput) {
  const response = await request.post<Result<StatutoryLeaveTemplateView>>("Operator/StatutoryTemplate", input);
  return response.data;
}

/**
 * Edits a catalogue row; copies no Hr changed follow it (owner Q4 b). Moving the row to another country once
 * copies exist answers 400 InvalidParameter(CountryId).
 */
export async function updateStatutoryCatalogueTemplate(id: number, input: StatutoryLeaveTemplateInput) {
  const response = await request.put<Result<StatutoryLeaveTemplateView>>(`Operator/StatutoryTemplate/${id}`, input);
  return response.data;
}

/** Archives a catalogue row. The companies' copies stay. */
export async function archiveStatutoryCatalogueTemplate(id: number) {
  const response = await request.delete<Result<boolean>>(`Operator/StatutoryTemplate/${id}`);
  return response.data;
}

/** Restores an archived catalogue row and copies it to companies still missing it. */
export async function restoreStatutoryCatalogueTemplate(id: number) {
  const response = await request.post<Result<StatutoryLeaveTemplateView>>(`Operator/StatutoryTemplate/${id}/Restore`);
  return response.data;
}

/** Support action "Re-copy missing statutory templates" for one company. Idempotent; returns the number added. */
export async function ensureCompanyStatutoryCopies(companyId: number) {
  const response = await request.post<Result<number>>(`Operator/StatutoryTemplate/Company/${companyId}/EnsureCopies`);
  return response.data;
}
